// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"_28mql","tooltipHolder":"_1vR28","tooltip":"_1VJg8"};